<template>
  <div class="loginLayout-wrap">
    <div class="loginLayout-header">
      <div class="w">
        <div class="logo" @click="handleReturnHome">
          <!-- <img src="@/assets/images/logo.png" alt=""> -->
          <div v-if="!$store.state.logoUrl">{{ $store.state.orgName }}</div>
          <img v-else :src="$store.state.logoUrl" alt="">
        </div>
        <div class="nav-right">
          <span @click="handleReturnHome">返回首页</span>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <div class="loginLayout-footer">
      <span>Copyright © 2020 北京学能通科技集团有限公司版权所有</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      logoUrl: localStorage.getItem('logoUrl')
    };
  },
  methods: {
    handleReturnHome () {
      this.$router.push({
        name: 'index',
        params: {
          url: window.localStorage.getItem('pcs_org_abbr')
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.loginLayout-wrap {
  background: #fff;
  width: 100%;
  min-height: 100vh;
  background: url("../assets/images/BG.png") no-repeat center;
  background-size: cover;
  background-attachment: fixed;

  .loginLayout-header {
    background: #fff;

    .w {
      @include container(1200px);
      height: 85px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo {
        font-size: 26px;
        font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
        font-weight: 600;
        color: #1cb17a;
        height: 85px;
        cursor: pointer;
        display: flex;
        align-items: center;

        img {
          max-height: 85px;

        }
      }

      .nav-right {
        width: 86px;
        border-radius: 20px;
        border: 1px solid #ff8b00;
        text-align: center;

        span {
          color: #ff8b00;
          font-size: 14px;
          line-height: 36px;
          cursor: pointer;
          text-decoration: none;
        }
      }
    }
  }

  .loginLayout-footer {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #fff;
    font-size: 12px;
    position: absolute;
    bottom: 0;
    z-index: 10;
  }
}</style>



// WEBPACK FOOTER //
// src/layout/loginLayout.vue